import { AccessorsMutatorsDecorator } from '../../helpers';
import { TranslatableModel } from './translatable-model';

/**
 * @class Account
 * @property {number} id
 * @property {string} name
 * @property {integer} status
 * @property {string} email
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} phone_code
 * @property {string} phone_number
 * @property {string} address
 * @property {date} created_at
 * @property {Country} country
 * @property {Property[]} properties
 */
export class GuestDocument extends TranslatableModel {

    formatUrl(value = this.url) {

        const split = (value || '').split('/');

        return split[split.length - 1];
    }
}

AccessorsMutatorsDecorator(
    'id',
    'url',
    'name',
    'guest_id',
    'reservation_id',
    'guest_type',
)(GuestDocument);



// WEBPACK FOOTER //
// ./src/pms-api/models/guest-document.model.js